import type { EndPlaybackSessionRequest } from "@/redux/certifications/types";

export const endPlaybackSessionOnUnload = ({
  sessionId,
  lastPositionSeconds,
}: Omit<EndPlaybackSessionRequest, "certificationSlug">) => {
  void fetch(
    `${import.meta.env.VITE_APP_BACKEND_URL}/certifications/playback-sessions/${sessionId}/end/`,
    {
      method: "POST",
      keepalive: true,
      credentials: "include",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ lastPositionSeconds }),
    },
  ).catch(() => undefined);
};
